export default __webpack_public_path__ + "static/media/logo_parkrun.5582613b.png";